import axios from 'axios';

const list = (countryId) => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Notifications/RegionCodes?countryId=${ countryId }`,
    withCredentials: true,
});

export default {
    list,
};
